export default __webpack_public_path__ + "static/media/ls_logo.0d886601.png";